import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    width: 182,
    flexBasis: 182,
    minWidth: 160,
  },
  textContainer: {
    height: 24,
    maxHeight: 24,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginLeft: 15,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
  },
  textBox: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: 500,
    fontSize: '14px',
    fontFamily: 'Rubik',
    lineHeight: '24px',
    letterSpacing: '1.25px',
    color: theme.palette.text.primary,
  },
  formBox: {
    height: '40px',
    width: '100%',
    display: 'flex',
    '&.closed': {
      display: 'none',
    },
  },
  customTriggerRoot: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.border.main}`,
    backgroundColor: theme.palette.background.paper,
    alignItems: 'stretch',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
    },
    '&:focus-visible': {
      outline: 'none',
      border: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.paper,
    },
  },
  customTriggerDisabled: {
    backgroundColor: theme.palette.background.default,
    borderColor: theme.palette.border.light,
    cursor: 'default',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      borderColor: theme.palette.border.light,
    },
  },
  customTriggerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: 0,
  },
  customTriggerValue: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  customTriggerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    color: theme.palette.icon.main,
    paddingRight: theme.spacing(1.5),
  },
  zeroStyles: {
    alignSelf: 'center',
    display: 'flex',
  },
}));

export default useStyles;
